import { camelCaseObject, getConfig } from "@edx/frontend-platform";
import { getAuthenticatedHttpClient } from "@edx/frontend-platform/auth";
import { SUPPORTED_LANGUAGES } from "../config";

const getOptions = () => ({
  headers: {
    "X-Platform": getConfig().PLATFORM_NAME || "pathways",
  },
});

export async function getThemeData() {
  const { data } = await getAuthenticatedHttpClient().get(
    `${getConfig().LMS_BASE_URL}/api/theme/`,
    {}
  );

  return data;
}

export async function getNotifications() {
  const { data } = await getAuthenticatedHttpClient().get(
    `${
      getConfig().LMS_BASE_URL
    }/api/ti/notifications/unread_list/?page_size=10`,
    {}
  );

  return camelCaseObject(data);
}

export async function updateNotifications(slug) {
  const { data } = await getAuthenticatedHttpClient().get(
    `${getConfig().LMS_BASE_URL}/api/ti/notifications/read/${slug}/`,
    {}
  );

  return camelCaseObject(data);
}

export async function getRoles() {
  const { data } = await getAuthenticatedHttpClient().get(
    `${getConfig().LMS_BASE_URL}/api/members/roles`,
    getOptions()
  );

  return data;
}

export async function getEvent() {
  const { data } = await getAuthenticatedHttpClient().get(
    `${getConfig().LMS_BASE_URL}/api/events/current/`,
    getOptions()
  );

  return data;
}

export async function getLocale(courseId) {
  const url = `${getConfig().LMS_BASE_URL}/course_lang/${courseId}/`;

  const { data } = await getAuthenticatedHttpClient().get(url);

  if (data?.lang && SUPPORTED_LANGUAGES.includes(data.lang)) {
    return data.lang;
  }

  return 'en';
}
